import { Asset } from "assets.gen";
import { audio } from "shared";

const buffers = new Map<string, AudioBuffer>();

let liftUpGain: GainNode | null = null;
let liftDownGain: GainNode | null = null;

const SFX_ASSETS: readonly string[] = [
  Asset.sfx_tune,
  Asset.sfx_bullet_hit,
  Asset.sfx_coin_collect,
  Asset.sfx_explosion,
  Asset.sfx_kick,
  Asset.sfx_lift_down,
  Asset.sfx_lift_up,
  Asset.sfx_speed_up,
  Asset.sfx_turret_shoot,
];

export async function loadAudio(): Promise<void> {
  let pending = SFX_ASSETS.length;
  return new Promise(resolve => {
    for (const asset of SFX_ASSETS) {
      fetch(asset)
        .then(r => r.arrayBuffer())
        .then(buf => audio.ctx.decodeAudioData(buf))
        .then(decoded => {
          buffers.set(asset, decoded);
          pending--;
          if (pending === 0) resolve();
        })
        .catch(err => {
          console.error(`Failed to load audio: ${asset}`, err);
          pending--;
          if (pending === 0) resolve();
        });
    }
  });
}

export function getBuffer(asset: string): AudioBuffer | null {
  return buffers.get(asset) ?? null;
}

export function playSound(asset: string, volume = 1): void {
  const buf = buffers.get(asset);
  if (!buf) return;
  audio.playSound(buf, volume);
}

export function playSoundAt(asset: string, x: number, screenW: number, volume = 1): void {
  const buf = buffers.get(asset);
  if (!buf) return;
  audio.playSoundAt(buf, x, screenW, volume);
}

let musicSource: AudioBufferSourceNode | null = null;

const MUSIC_LOOP_START = 15;
const MUSIC_LOOP_END = 76;

export function playMusic(): void {
  const buf = buffers.get(Asset.sfx_tune);
  if (!buf) return;
  stopMusic();
  audio.unlock();
  musicSource = audio.playMusic(buf, true, MUSIC_LOOP_START, MUSIC_LOOP_END);
  audio.fadeMusicIn(musicSource, 1);
}

export function stopMusic(): void {
  if (musicSource) {
    try {
      musicSource.stop();
    } catch {}
    musicSource = null;
  }
  audio.fadeMusicOut(0.5);
}

export function initLiftSounds(): void {
  const upBuf = buffers.get(Asset.sfx_lift_up);
  const downBuf = buffers.get(Asset.sfx_lift_down);
  if (upBuf) {
    const result = audio.createLoopingSource(upBuf);
    liftUpGain = result.gain;
  }
  if (downBuf) {
    const result = audio.createLoopingSource(downBuf);
    liftDownGain = result.gain;
  }
}

export function setLiftVolume(up: number, down: number): void {
  if (liftUpGain) liftUpGain.gain.value = up * 0.1;
  if (liftDownGain) liftDownGain.gain.value = down * 0.1;
}
